import { render, staticRenderFns } from "./truck.vue?vue&type=template&id=57473710&scoped=true&"
var script = {}
import style0 from "./truck.vue?vue&type=style&index=0&id=57473710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57473710",
  null
  
)

export default component.exports